"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var ramda_1 = require("ramda");
var w3c_1 = require("../../../helpers/w3c");
var classNames_1 = __importDefault(require("./classNames"));
var getTag = function (as, href) {
    if (as) {
        return as;
    }
    if (href) {
        return 'a';
    }
    return 'div';
};
var ElementTag = function (props) {
    var as = props.as, href = props.href, children = props.children, className = props.className, innerRef = props.innerRef, rest = __rest(props, ["as", "href", "children", "className", "innerRef"]);
    var Tag = getTag(as, href);
    var classes = classNames_1["default"](className);
    var refProps = {};
    if (innerRef) {
        if (ramda_1.is(String, Tag)) {
            refProps.ref = innerRef;
        }
        else {
            refProps.innerRef = innerRef;
        }
    }
    return (react_1["default"].createElement(Tag, __assign({ className: classes, href: href }, refProps, w3c_1.sanitizeProps(Tag, [], rest)), children));
};
exports["default"] = ElementTag;
//# sourceMappingURL=ElementTag.js.map